import React from 'react';
import hero6 from '../../assets/images/hero-bg/hero-6.jpg';
import projectLogo from '../../assets/images/logos/ca-logo-white.png';
import Typography from '@material-ui/core/Typography';

const MaintenancePage = () => (
  <div
    style={{
      height: '100vh',
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      backgroundImage: 'url(' + hero6 + ')',
      backgroundSize: 'cover',
      color: 'black',
    }}>
    <div>
      <img alt="CA" src={projectLogo} style={{ width: '100px', marginBottom: 10 }} />
    </div>

    <Typography variant="h4" style={{ fontWeight: 'bold', margin: '20px' }}>
      We&rsquo;ll be back soon!
    </Typography>

    <p>
      Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. we&rsquo;ll be back online
      shortly!
    </p>

    <p>&mdash; The Team</p>
  </div>
);

export default MaintenancePage;
